module.exports = __webpack_public_path__ + "img/polar-bear.e809d328.svg";